import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";
import { createDataAttributes } from "../../utilities";

import "./ActionCard.scss";

const ActionCardContainer = ({ children, className, dataAttrib, ...rest }) => {
  return (
    <div
      className={classnames("uikit__action-card-container", className)}
      {...createDataAttributes(dataAttrib)}
      {...rest}
    >
      {children}
    </div>
  );
};

ActionCardContainer.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.element]).isRequired,
  className: propTypes.string,
  dataAttrib: propTypes.arrayOf(Object)
};

ActionCardContainer.defaultProps = {};

export default ActionCardContainer;
